export default __webpack_public_path__ + "static/smile-d6385510380b15b0fd7f78f03875fe89.png";